export const GET_CONVERSATIONS_REQUEST = 'GET_CONVERSATIONS_REQUEST';
export const GET_CONVERSATIONS_SUCCESS = 'GET_CONVERSATIONS_SUCCESS';
export const GET_CONVERSATION_FAILURE = 'GET_CONVERSATION_FAILURE';

export const GET_MESSAGES_REQUEST = 'GET_MESSAGES_REQUEST';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_FAILURE = 'GET_MESSAGES_FAILURE';

export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';

export const ADD_MESSAGE = 'ADD_MESSAGE';

export const APPEND_PREVIOUS_MESSAGE_REQUEST = 'APPEND_PREVIOUS_MESSAGE_REQUEST';
export const APPEND_PREVIOUS_MESSAGE_SUCCESS = 'APPEND_PREVIOUS_MESSAGE_SUCCESS';
export const APPEND_PREVIOUS_MESSAGE_FAILURE = 'APPEND_PREVIOUS_MESSAGE_FAILURE';

export const GET_UNREAD_MESSAGES_COUNT_REQUEST = 'GET_UNREAD_MESSAGES_COUNT_REQUEST';
export const GET_UNREAD_MESSAGES_COUNT_SUCCESS = 'GET_UNREAD_MESSAGES_COUNT_SUCCESS';
export const GET_UNREAD_MESSAGES_COUNT_FAILURE = 'GET_UNREAD_MESSAGES_COUNT_FAILURE';

export const SET_ALL_MESSAGES_READ_REQUEST = 'SET_ALL_MESSAGES_READ_REQUEST';
export const SET_ALL_MESSAGES_READ_SUCCESS = 'SET_ALL_MESSAGES_READ_SUCCESS';
export const SET_ALL_MESSAGES_READ_FAILURE = 'SET_ALL_MESSAGES_READ_FAILURE';

export const SELECT_CONVERSATION = 'SELECT_CONVERSATION';

export const CLEAR_CHAT_CONTEXT = 'CLEAR_CHAT_CONTEXT';
